<script lang="ts" setup>
import { computed } from "vue";
import { TravelOrderPaymentStatus, TravelOrderPaymentStatusLabel } from "@/constants/travelOrder";

const props = defineProps<{
  status: TravelOrderPaymentStatus;
}>();

const label = computed(() => {
  return TravelOrderPaymentStatusLabel[props.status];
});
</script>

<template>
  <v-chip class="bg-grey-lighten-5 text-grey-darken-3" density="comfortable" size="x-small">{{ label }}</v-chip>
</template>

<style lang="scss" scoped></style>
